import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineFlag } from "react-icons/md";

import { STATUS_LABELS } from "../../../../../constants/common";
import Button from "../../../../Button";
import ProjectGoal from "../../../../modals/common/ProjectGoalModal";
import ProjectStepsModal from "../../../../modals/common/ProjectStepsModal";
import ApproveModal from "../../../../modals/teacher/ApproveModal";
import DisapproveModal from "../../../../modals/teacher/DisapproveModal";

const SubmissionsHeader = ({ onSubmit, rest }) => {
  const { t } = useTranslation();
  const projectGoalModalRef = useRef();
  const projectStepsModalRef = useRef();

  const approveModalRef = useRef();
  const disApproveModalRef = useRef();

  const openApproveModal = (projectID, isPlaygroundProject) => {
    approveModalRef.current?.openModal(projectID, isPlaygroundProject);
  };

  const openDisapproveModal = (projectID) => {
    disApproveModalRef.current?.openModal(projectID);
  };

  const handleApproveModalRefSuccess = () => {
    onSubmit();
  };

  const handleDisapproveModalRefSuccess = () => {
    onSubmit();
  };

  const openProjectGoalModal = (projectData) => projectGoalModalRef.current?.openModal(projectData);
  const openProjectStepsModal = (projectData) => projectStepsModalRef.current?.openModal(projectData);

  const handleProjectGoalSuccess = () => {};

  return (
    <div className="relative mb-2 flex items-center justify-between">
      <div className="flex-1 items-center text-blue-500">
        <p className="mb-1 text-xl">{rest.studentName}</p>
        {rest?.isPlaygroundProject ? null : (
          <p>
            {t("status")}: <span>{t(STATUS_LABELS[rest?.codeData?.last_status_id])}</span>
          </p>
        )}
        {rest?.isPlaygroundProject ? (
          <p className="absolute left-[38%] top-[45px] min-w-80 text-center text-xl">{rest.lessonName}</p>
        ) : (
          <p className="absolute left-[38%] top-[70px] min-w-80 text-center text-xl">{rest.lessonName}</p>
        )}
      </div>
      {(rest?.codeData?.last_status_id == 2 || rest?.codeData?.last_status_id == 5) && (
        <div className="flex flex-1 justify-center space-x-2">
          <Button
            className="w-44"
            color="green"
            label={t("approve")}
            onClick={() => openApproveModal(rest?.codeData?.id, rest?.isPlaygroundProject)}
          />
          <Button
            className="w-44"
            color="red"
            label={t("disapprove")}
            onClick={() => openDisapproveModal(rest?.codeData?.id)}
          />
        </div>
      )}

      {rest?.isPlaygroundProject ? (
        <div className="flex-1"></div>
      ) : rest?.projectGoal?.projectGoal ? (
        <div className="flex flex-1 items-center justify-end space-x-2">
          <Button
            color="yellow"
            variant="outlined"
            iconLeft={<MdOutlineFlag />}
            label={t("check_project_goal")}
            onClick={() => openProjectGoalModal(rest.projectGoal)}
          />
        </div>
      ) : (
        <div className="flex flex-1 items-center justify-end space-x-2">
          <Button
            color="yellow"
            variant="outlined"
            iconLeft={<MdOutlineFlag />}
            label={t("check_project_steps")}
            onClick={() => openProjectStepsModal(rest)}
          />
        </div>
      )}
      <ProjectGoal ref={projectGoalModalRef} onSubmit={handleProjectGoalSuccess} />
      <ProjectStepsModal ref={projectStepsModalRef} />
      <ApproveModal ref={approveModalRef} onSubmit={handleApproveModalRefSuccess} />
      <DisapproveModal ref={disApproveModalRef} onSubmit={handleDisapproveModalRefSuccess} />
    </div>
  );
};

export default SubmissionsHeader;
